<template>
<div>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="orange" :disabled="loading || !param.id" :loading="saving" text x-large>
        <v-icon left>fas fa-file-pdf</v-icon>PDF
      </v-btn>
    </template>
    <v-list dense>
      <template v-if="enableFormat('見積書')">
        <v-list-item @click="createPDF('estimate')" :disabled="!param.estimateDate">
          <v-list-item-title>見積書</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="enableFormat('注文書')">
        <v-list-item @click="createPDF('order')" :disabled="!param.estimateDate">
          <v-list-item-title>注文書</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="enableFormat('注文請書')">
        <v-list-item @click="createPDF('order-receive')" :disabled="!param.orderDate">
          <v-list-item-title>注文請書</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="enableFormat('請求書')">
        <v-list-item @click="createPDF('claim')" :disabled="!param.claimDate">
          <v-list-item-title>請求書</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="enableFormat('納品書')">
        <v-list-item @click="createPDF('delivery')" :disabled="!param.deliveryDate">
          <v-list-item-title>納品書</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="enableFormat('発注書')">
        <v-list-item @click="createPDF('self-order')" :disabled="!param.orderDate">
          <v-list-item-title>発注書</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</div>
</template>

<script>
import { API, Storage, graphqlOperation } from 'aws-amplify'
import { updateOrder } from '../graphql/mutations'
import { listAppOptions } from '../graphql/queries'
import pdfMake from 'pdfmake/build/pdfmake'
//import pdfMake from '@/assets/pdfmake/pdfmake.min.js'
import '@/assets/vfs_fonts.js'

export default {
  data() {
    return {
      appOptions: {},
      logoURL: null,
      signURL: null,
      type: null,
      defaultStyle: {
        font: 'GenShin',
        //font: 'ZenKakuGothicAntique',
        fontSize: 10,
      },
      styles: {
        headerA: {
            fontSize: 20,
            alignment: 'center',
        },
        headerB: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            //color: '#FFF',
            fillColor: '#F1F1F1',
            margin: [0, 8, 0, 0]
        },
        large: {
            fontSize: 16,
        },
        small: {
            fontSize: 8,
        },
        alignRight: {
            alignment: 'right',
        },
      }
    }
  },
  props: {
    param: {
      type: Object,
      default: () => ({}),
    },
    corporate: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    formatList: {
      type: Array,
      default: () => ([
        '見積書',
        '注文書',
        '注文請書',
        '請求書',
        '納品書',
      ]),
    },
  },
  mounted: async function() {
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
      
    //PDFデフォルト設定
    pdfMake.fonts = {
      GenShin: {
        normal: 'GenShinGothic-Normal-Sub.ttf',
        bold: 'GenShinGothic-Normal-Sub.ttf',
        italics: 'GenShinGothic-Normal-Sub.ttf',
        bolditalics: 'GenShinGothic-Normal-Sub.ttf',
      },
      /*
      ZenKakuGothicAntique: {
        normal: 'ZenKakuGothicAntique-Regular.ttf',
        bold: 'ZenKakuGothicAntique-Bold.ttf',
        italics: 'ZenKakuGothicAntique-Regular.ttf',
        bolditalics: 'ZenKakuGothicAntique-Regular.ttf',
      },
      */
    }
    pdfMake.tableLayouts = {
      lightLayout: {
        hLineWidth(i) {
          if (i === 0) return 0
          return 1
        },
        vLineWidth() { return 0 },
        hLineColor() { return '#666' },
      },
      stripeLayout: {
        hLineWidth(i) {
          if (i === 0) return 0
          return 1
        },
        vLineWidth() { return 0 },
        hLineColor() { return '#666' },
        fillColor(i) { return i%2 == 0 ? '#FFF' : '#f5f7ff' },
      },
      stripeTableLayout: {
        hLineWidth() { return 1 },
        hLineColor() { return '#666' },
        vLineWidth() { return 1 },
        vLineColor() { return '#666' },
        fillColor(i) {
          if (i == 0) return '#DDD'
          return i%2 == 0 ? '#FFF' : '#f5f7ff'
        },
      },
      borderlessLayout: {
        hLineWidth() { return 0 },
        vLineWidth() { return 0 },
      },
      amountLayout: {
        hLineWidth(i) {
          if (i === 0) return 0
          return 2
        },
        vLineWidth() { return 0 },
        hLineColor() { return '#666' },
      },
    }
  },
  computed: {
    customerName() {
      try {
        return this.param.customerID.text
      } catch (e) {
        return null
      }
    },
    orderNo() {
      try {
        return this.type != 'self-order' ? this.param.id : this.param.no
      } catch (e) {
        return null
      }
    },
    orderTitle() {
      try {
        return this.param.title
      } catch (e) {
        return null
      }
    },
    subtotal() {
      try {
        let val = 0
        if (this.param.items.length > 0) {
          for (const item of this.param.items) {
            if (item.quantity && item.value) {
              val += parseInt(item.quantity) * parseInt(item.value)
            }
          }

        } else {
          val = this.param.amount
        }

        return val

      } catch (e) {
        return 0
      }
    },
    total() {
      try {
        return this.separate( Math.floor(this.subtotal * (this.param.tax / 100 + 1)) )
      } catch (e) {
        return null
      }
    },
    address() {
      const map = []
      const contact = []

      map.push(this.corporate.name)

      //支店・営業所を指定
      if (this.param.officeID) {
        const office = this.corporate.office.items.find(e => e.id == this.param.officeID.value)
        if (office) {
          map.push(office.name)
          map.push('〒' + office.post + ' ' + office.pref + office.address)
          if (office.build) map.push(office.build)
          if (office.tel) contact.push('TEL ' + office.tel)
          if (office.fax) contact.push('FAX ' + office.fax)
        }
      
      //指定なし
      } else {
        map.push('〒' + this.corporate.post + '' + this.corporate.pref + this.corporate.address)
        if (this.corporate.build) map.push(this.corporate.build)
        if (this.corporate.tel) contact.push('TEL ' + this.corporate.tel)
        if (this.corporate.fax) contact.push('FAX ' + this.corporate.fax)
      }
      
      if (contact.length > 0) map.push(contact.join(' / '))
      if (this.param.chargeID) map.push('担当　' + this.param.chargeID.text)
      
      //インボイス制度登録番号
      if (this.corporate.invoice) map.push('登録番号　' + this.corporate.invoice)

      return this.type != 'order' ? map.join('\n') : ''
    },
  },
  watch: {
    corporate(val) {
      //ロゴ
      if (val.logo) {
        this.getImageURL(val.logo, 'logoURL')
      } else {
        this.logoURL = null
      }
      //社印
      if (val.sign) {
        this.getImageURL(val.sign, 'signURL')
      } else {
        this.signURL = null
      }
      if (val.bank) {
        val.bank.items.sort(function(a, b) {
          if (a.sort < b.sort) return -1
          if (a.sort > b.sort) return 1
          return 0
        })
      }
    }
  },
  methods: {
    //PDFの作成
    async createPDF(formatType) {
      this.type = formatType

      const docDefinition = {
        info: {
          title: this.orderNo + '_' + this.customerName + '様_' + this.orderTitle + '_' + this.headerFormat().text,
        },
        content: [],
        defaultStyle: this.defaultStyle,
        styles: this.styles,
      }

      docDefinition.content.push(this.headerFormat())
      docDefinition.content.push(this.titleFormat())
      docDefinition.content.push(this.listFormat())
      docDefinition.content.push(this.listFooterFormat())
      docDefinition.content.push(this.footerFormat())
      //docDefinition.content.push(this.signFormat())

      //pdfMake.createPdf(docDefinition).open({}, window.open('', '_blank'))
      pdfMake.createPdf(docDefinition).download(docDefinition.info.title + '.pdf')

      // 伝票発行済にする
      await API.graphql(graphqlOperation(updateOrder, {input: {
        id: this.param.id,
        publish: true,
      }}))
      this.log({ type: this.$route.name, text: '[' + this.param.id + '] の伝票を発行しました' })
    },
    //ヘッダのフォーマット
    headerFormat() {
      let layout = 'headerA'
      if (this.corporate.slipFormat == 'タイプB') layout = 'headerB'

      let title = '御見積書'
      let dateName, dateStr

      switch (this.type) {
        case 'claim':
          title = '御請求書'
          dateName = '御請求日'
          dateStr = this.param.claimDate
          break

        case 'delivery':
          title = '納品書'
          dateName = '納品日'
          dateStr = this.param.deliveryDate
          break

        case 'order':
          title = '注文書'
          dateName = '注文日'
          dateStr = ''
          break

        case 'order-receive':
          title = '注文請書'
          dateName = '注文請日'
          dateStr = this.param.orderDate
          break

        case 'self-order':
          title = '発注書'
          dateName = '発注日'
          dateStr = this.param.orderDate
          break

        default:
          dateName = '御見積日'
          dateStr = this.param.estimateDate
          break
      }

      const right = []
      //No 日付
      right.push([
        {
          layout: 'lightLayout',
          table: {
            widths: ['auto', '*', 'auto'],
            body: [
              ['No.', '', { text: this.orderNo, style: 'alignRight' }],
              [dateName, '', { text: dateStr, style: 'alignRight' }],
            ]
          }
        }
      ])

      //フォーマットB
      if (layout == 'headerB') {
        return {
          layout: 'noBorders',
          margin: [0, 0, 0, 20],
          table: {
            widths: [250, '*', 230],
            body: [
              [
                { text: title, style: layout },
                {},
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['*'],
                    body: right,
                  }
                }
              ]
            ]
          },
          text: title,
        }

      //それ以外
      } else {
        return {
          layout: 'noBorders',
          margin: [0, 0, 0, 20],
          table: {
            widths: ['*', 200, '*'],
            body: [
              [
                {},
                { text: title, style: layout },
                {}
              ]
            ]
          },
          text: title,
        }
      }
    },
    //タイトルのフォーマット
    titleFormat() {
      let dateName, dateStr, titleStr, other

      let layout = 'headerA'
      if (this.corporate.slipFormat == 'タイプB') layout = 'headerB'
      
      switch (this.type) {
        case 'claim':
          dateName = '御請求日'
          dateStr = this.param.claimDate
          titleStr = '上記の件について、下記の通りご請求致します。'

          var bank = []
          for (const item of this.corporate.bank.items) {
            bank.push(item.name + '  ' + item.store + '\n' + 
              item.type + '  ' + item.no + '  ' + item.owner)
          }
          other = [
            ['[ 支払期限 ]', this.param.fixedDate],
            ['[ 振  込  先 ]', bank.join('\n')]
          ]
          break

        case 'delivery':
          dateName = '納品日'
          dateStr = this.param.deliveryDate
          titleStr = '上記の件について、下記の通り納品致します。'
          other = [
            ['[ 支払条件 ]', this.param.paymentTerms]
          ]
          break

        case 'order':
          dateName = '注文日'
          dateStr = ''
          titleStr = '上記の件について、下記の通り注文します。'
          other = [
            ['[ 支払条件 ]', this.param.paymentTerms]
          ]
          break

        case 'order-receive':
          dateName = '注文請日'
          dateStr = this.param.orderDate
          titleStr = '上記の件について、下記の通り注文をお請けいたします。'
          other = [
            ['[ 支払条件 ]', this.param.paymentTerms]
          ]
          break

        case 'self-order':
          dateName = '発注日'
          dateStr = this.param.orderDate
          titleStr = '上記の件について、下記の通り発注致します。'

          other = [
            ['[ 支払方法 ]', this.param.payment],
          ]
          break
          
        default:
          dateName = '御見積日'
          dateStr = this.param.estimateDate
          titleStr = '上記の件について、下記の通り御見積り申し上げます。'
          other = [
            ['[ 有効期限 ]', this.param.estimateLimit],
            ['[ 支払条件 ]', this.param.paymentTerms]
          ]
          break
      }

      //ロゴ
      let logo = {
        widths: ['auto'],
        body: [
          ['']
        ]
      }
      //ロゴあり
      if (this.logoURL && this.type != 'order') {
        logo = {
          widths: ['auto'],
          body: [
            [
              {
                image: this.logoURL,
                width: 100,
              },
            ],
          ]
        }
      }

      //社印
      let sign = {
        widths: ['auto'],
        body: [
          ['']
        ]
      }
      //社印
      if (this.signURL && this.type != 'order') {
        sign = {
          widths: ['auto'],
          body: [
            [
              {
                image: this.signURL,
                width: 50,
              },
            ],
          ]
        }
      }
      let signY = this.logoURL ? 160 : 140

      const target = this.type != 'order' ? [this.customerName, '', '御中'] : [this.corporate.name, '', '宛']

      const right = []
      if (layout != 'headerB') {
        //No 日付
        right.push([
          {
            layout: 'lightLayout',
            table: {
              widths: ['auto', '*', 'auto'],
              body: [
                ['No.', '', { text: this.orderNo, style: 'alignRight' }],
                [dateName, '', { text: dateStr, style: 'alignRight' }],
              ]
            }
          }
        ])
      }
      //ロゴ
      right.push([
        {
          layout: 'borderlessLayout',
          table: logo,
        }
      ])
      //社名
      right.push([
        {
          layout: 'borderlessLayout',
          absolutePosition: { x:500, y:signY },
          table: sign,
        }
      ])
      //住所
      right.push([
        this.address
      ])
      //合計タイトル
      var totalTitle = '合計金額'
      if (this.param.tax > 0) totalTitle += '(税込)'
      
      return {
        layout: 'noBorders',
        table: {
          widths: [250, '*', 230],
          body: [
            [
              {
                layout: 'noBorders',
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        layout: 'lightLayout',
                        table: {
                          widths: ['auto', '*', 20],
                          body: [
                            target,
                            [this.orderTitle, '', ''],
                          ]
                        }
                      }
                    ],
                    [ { text: titleStr, margin: [0, 10] } ],
                    [
                      {
                        layout: 'amountLayout',
                        table: {
                          widths: ['auto', '*', 'auto'],
                          body: [
                            [
                              { text: totalTitle, style: 'large' }, 
                              '', 
                              { text: this.total + ' 円', style: 'large' }
                            ],
                          ],
                        }
                      }
                    ],
                    [
                      {
                        layout: 'noBorders',
                        table: {
                          widths: [60, '*'],
                          body: other,
                        }
                      }
                    ],
                  ]
                }
              },
              {},
              {
                layout: 'noBorders',
                table: {
                  widths: ['*'],
                  body: right,
                }
              },
            ],
          ]
        }
      }
    },
    //品目のフォーマット
    listFormat() {
      const maxRows = 15
      const map = [
        [
          '品名・品番', 
          '数量', 
          { text: '単価', style: 'alignRight' }, 
          { text: '金額', style: 'alignRight' },
          '備考', 
        ]
      ]
      
      for (const item of this.param.items) {
        map.push([
          item.name || '　',
          { text: item.quantity ? this.separate(item.quantity) + item.unit : '' },
          { text: item.value ? this.separate(item.value) : '', style: 'alignRight' },
          { text: item.value ? this.separate(item.quantity * item.value) : '', style: 'alignRight' },
          item.remarks || '　',
        ])
      }
      if (map.length < maxRows) {
        for (let i=map.length; i<=maxRows; i++) {
          map.push(['　', '', '', '', ''])
        }
      }

      let layout = 'stripeLayout'
      if (this.corporate.slipFormat == 'タイプB') layout = 'stripeTableLayout'

      return {
        layout: layout,
        table: {
          widths: ['*', 50, 50, 70, 100],
          body: map
        },
        margin: [0, 10]
      }
    },
    //品目フッターのフォーマット
    listFooterFormat() {
      const amount = this.subtotal
      const tax = Math.floor(amount * (this.param.tax / 100))
      const body = []

      if (tax > 0) body.push([ '小計', '', { text: this.separate(amount), style: 'alignRight'} ])
      if (tax > 0) body.push([ '消費税 (' + this.param.tax + '%)', '', { text: this.separate(tax), style: 'alignRight'} ])
      body.push([ '合計', '', { text: this.separate(amount + tax), style: 'alignRight'} ])

      return {
        layout: 'noBorders',
        table: {
          widths: ['*', 200, 100],
          body: [
            [
              '',
              {
                layout: 'lightLayout',
                table: {
                  widths: [100, '*', 'auto'],
                  body: body
                }
              },
              ''
            ]
          ]
        },
      }
    },
    //フッターのフォーマット
    footerFormat() {
      return {
        layout: 'noBorders',
        table: {
          widths: ['100%'],
          body: [
            [ '[   備考   ]' ],
            [ this.param.remarks ]
          ]
        },
      }
    },
    //S3バケットのURLを返す
    async getImageURL(key, target) {
      try {
        const ret = await Storage.get(key, { download: true })
        this[target] = await this.readBlogToURIAsync(ret.Body)
        
      } catch(e) {
        //console.log(e)
      }
    },
    enableFormat(name) {
      return this.formatList.find(e => e == name) ? true : false
    },
  },
}
</script>

<style lang='scss' scoped>

</style>
